export default __webpack_public_path__ + "static/media/gradissue22.titleanimation.91e66074.gif";